export interface BillToCompanyMappingEntity {
    id?: number | null,
    priority?: number | null,
    tempPriority?: number | null,
    chargeType?: string | null,
    operatingTml?: string | null,
    cntrStatus?: string | null,
    subChargeType?: string | null,
    billToCompanyCode: string | null,
    soa?: string | null,
    owner?: string | null,
    forwarderCode?: string | null,
    forwarderReference?: string | null,
    vesselType?: string | null,
    chargeCode?: string | null,
    consortiumCode?: string | null,
    serviceCode?: string | null,
    activeInd: string | null,
    mappingType: string,
    billToFromCompanyCode?: string | null,  //update by  betty

    [key: string]: string | boolean | null | Object | undefined
}

export const EMPTY_BILL_TO_COMPANY_MAPPING_ENTITY: BillToCompanyMappingEntity = {

    id: 0,
    priority: null,
    tempPriority: null,
    chargeType: null,
    operatingTml: null,
    cntrStatus: null,
    subChargeType: null,
    billToCompanyCode: null,
    soa: null,
    owner: null,
    forwarderCode: null,
    forwarderReference: null,
    vesselType: null,
    chargeCode: null,
    consortiumCode: null,
    serviceCode: null,
    activeInd: 'Y',
    mappingType: "BillToCompanyMappingEntity",
}